import React from 'react';
import * as svgs from './svgs-raw';

export type $SvgName = keyof typeof svgs;
export const svgNames = Object.keys(svgs) as $SvgName[];

export function SvgImage({name}: {name: $SvgName}) {
  const Component = svgs[name];

  return <Component />;
}
